import React, { useEffect, useState } from 'react';
import { Workspace } from 'src/common/models/common-types';
import { Box, IconButton, List, ListItemButton, ListItemText, OutlinedInput, Typography } from '@mui/material';
import { findWorkspaces } from '../../utils';
import { i18n } from 'src/common/i18n/i18n';
import { COLORS } from 'src/common/constants/constants';
import { IconSearch } from 'src/common/images';
import { getUrlQuery } from 'src/common/utils/communication';
import { useNavigate } from 'react-router-dom';

interface WorkspacesSelectionMenuProps {
    activeWorkspace: Workspace | null;
    onChangeWorkspace(ws: Workspace): void;
    workspaces: Workspace[];
    onCloseCallback: () => void;
}

const WorkspacesSelectionMenu: React.FC<WorkspacesSelectionMenuProps> = ({
    activeWorkspace,
    onChangeWorkspace,
    workspaces,
    onCloseCallback,
}) => {
    const [searchInput, setSearchInput] = useState('');
    const [workspacesFilter, setWorkspacesFilter] = useState(workspaces);
    const navigate = useNavigate();

    useEffect(() => {
        setWorkspacesFilter(findWorkspaces(workspaces, searchInput));
    }, [searchInput, workspaces]);
    useEffect(() => {
        setTimeout(() => document.querySelector('.remove-tab-index')?.removeAttribute('tabindex'));
    }, []);

    const onSelectWorkspace = (ws: Workspace) => {
        if (window.location.pathname.includes(`${process.env.PUBLIC_URL}/report`)) {
            navigate(`/collections${getUrlQuery()}`);
        }
        onChangeWorkspace(ws);
        onCloseCallback();
    };

    return (
        <Box sx={{ m: 1, position: 'relative', maxHeight: 300, overflowY: 'auto' }}>
            <Box
                sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'white' }}
                className="background-color-l remove-tab-index"
            >
                <Typography sx={{ pb: 1 }} variant="s14w700">
                    {i18n.translate('Switch Workspace')}
                </Typography>
                <OutlinedInput
                    autoFocus
                    sx={{
                        'width': '100%',
                        'borderRadius': '8px',
                        '&:hover fieldset': { border: `1px solid ${COLORS.BRAND_HOVER} !important` },
                        'height': '40px',
                    }}
                    placeholder={i18n.translate('Search Workspace')}
                    size="medium"
                    type="text"
                    value={searchInput}
                    onChange={(event) => setSearchInput(event.target.value)}
                    startAdornment={
                        <IconButton edge="start" className="fill-bd">
                            <IconSearch />
                        </IconButton>
                    }
                />
            </Box>
            <List sx={{ mt: 1, mb: 1, maxHeight: 400 }}>
                {workspacesFilter.map((ws) => (
                    <ListItemButton
                        sx={{ height: 32, border: '0px !important', p: '4px 8px' }}
                        className={`background-color-hover-mho ${
                            ws.id === activeWorkspace?.id ? 'background-color-blst' : ''
                        }`}
                        key={ws.id}
                        selected={ws.id === activeWorkspace?.id}
                        onClick={() => onSelectWorkspace(ws)}
                    >
                        <ListItemText
                            primary={
                                <Typography className="color-bd" sx={{ fontWeight: '400 !important' }}>
                                    {ws.name}
                                </Typography>
                            }
                        />
                    </ListItemButton>
                ))}
            </List>
        </Box>
    );
};

export default WorkspacesSelectionMenu;
